import React, { Children } from 'react';
import PropTypes from 'prop-types';
import FormValidator from './form-validator';
import typeOf from '../../utils/typeOf';

const Form = ({
  onSubmit,
  onSuccess,
  onReject,
  children,
  ...rest
}) => {
  const formElements = [];
  const loadFormElements = (childs) => {
    Children.forEach(childs, (child) => {
      if (
        typeof child === 'undefined'
        || typeOf(child) === 'null'
        || typeOf(child) !== 'object'
        || typeOf(child.props) !== 'object') {
        return;
      }
      if (typeOf(child.props.name) !== 'undefined') {
        formElements.push(child);
      }
      if (typeOf(child.props.children) !== 'undefined') {
        loadFormElements(child.props.children);
      }
    });
  };
  loadFormElements(children);

  const handleFormAction = (e) => {
    e.preventDefault();
    let fullyOk = true;
    const ret = {};

    formElements.forEach((formElement) => {
      const status = FormValidator.check(formElement);
      ret[status.name] = {
        ok: status.ok,
        value: status.value,
        errors: status.errors,
      };
      if (status.errors.length) {
        fullyOk = false;
      }
    });
    if (fullyOk) {
      onSuccess(ret);
    } else {
      onReject(ret);
    }
    onSubmit(ret);
  };

  return (
    <form
      onSubmit={handleFormAction}
      onInvalid={handleFormAction}
      {...rest}
    >
      {children}
    </form>
  );
};

Form.propTypes = {
  /** will fire when form submited.
  {
    **formElement.name*: {
      value: Any,
      errors: Array,
      ok: Boolean,
    },
    ...
  }
  */
  onSubmit: PropTypes.func,
  /** will fire only when form submit everythings is ok.
  {
    **formElement.name*: {
      value: Any,
      errors: Array,
      ok: Boolean,
    },
    ...
  }
  */
  onSuccess: PropTypes.func,
  /** will fire only when form submited and raised some errors.
  {
    **formElement.name*: {
      value: Any,
      errors: Array,
      ok: Boolean,
    },
    ...
  }
  */
  onReject: PropTypes.func,
};

Form.defaultProps = {
  onSubmit: () => {},
  onSuccess: () => {},
  onReject: () => {},
};

export default Form;

export {
  Form,
  FormValidator,
};
